export const corporateSignatures = state => {
  return state.corporateSignatures.filter(signature => signature.active);
};
